export const getAi = state => state.ai

// SETTINGS
export const getAiSettings = state => getAi(state).get('settings')
export const getAiSettingsLocale = state => getAiSettings(state).get('locale')

// ANALYSIS
export const getAiAnalysis = state => getAi(state).get('analysis')
export const getAiAnalysisLoading = state => getAiAnalysis(state).get('loading')
export const getAiAnalysisAnalysis = state => getAiAnalysis(state).get('analysis')
export const getAiAnalysisShowDialog = state => getAiAnalysis(state).get('showDialog')
export const getAiAnalysisPrompt = state => getAiAnalysis(state).get('prompt')
export const getAiAnalysisMode = state => getAiAnalysis(state).get('mode')
export const getAiAnalysisAutoDetectMode = state => getAiAnalysis(state).get('autoDetectMode')
export const getAiAnalysisAdditionalModes = state => getAiAnalysis(state).get('additionalModes')

// UI
export const getAiUi = state => getAi(state).get('ui')
export const getAiUiShowOrderSummariesDialog = state => getAiUi(state).get('showOrderSummariesDialog')
